//import Cookies from 'js-cookie';
import { lock, unlock } from 'tua-body-scroll-lock'

document.addEventListener('DOMContentLoaded',function() {
    
    const el = document.getElementById('popup');

    window.popup = function() {
        const closePopup = function() {
            document.removeEventListener('click', clickOutside);
            
            el.classList.add('move-out');
            
            setTimeout(function() {
                el.style.display = 'none';
                el.classList.remove('block');
            }, 250);
            
            document.documentElement.classList.contains('desktop') ? unlock() : false;

            //Cookies.set("tmobile-popup2k3", 1, { expires: 356, path: '/' });
        };
        
        const openPopup = function() {
            const accept = el.getElementsByClassName('js-accept')[0];
            
            el.classList.add('block');
//            el.style.display = 'block';
            
            setTimeout(function() {
                el.classList.remove('move-out');
            }, 250);
            
            document.addEventListener('click', clickOutside);
            
            accept.addEventListener('click', function(e) {
                e.preventDefault();
                closePopup();
            });
            
            document.documentElement.classList.contains('desktop') ? lock() : false;
        };
        
        const clickOutside = function(e) {
            e.target.closest('.js-window') === null ? closePopup() : false;
        }
        
        openPopup();

        //Cookies.get('tmobile-popup2k3') != 1 ? openPopup() : false;
    };

    //el ? init() : false;

}, false)
